import * as yup from "yup";

const urlRegex = /^((ftp|http|https):\/\/)?(www.)?(?!.*(ftp|http|https|www.))[a-zA-Z0-9_-]+(\.[a-zA-Z]+)+((\/)[\w#]+)*(\/\w+\?[a-zA-Z0-9_]+=\w+(&[a-zA-Z0-9_]+=\w+)*)?$/gm

export const enterIntegrationUrlFormSchema = yup.object().shape({
  integrationUrl: yup.string().required("Required").matches(urlRegex, 'URL is not valid')
});
